import {detailServicesPath} from "../../Constants";
import axios from "axios";

const detailControllerRestUrl =
    detailServicesPath + "/organizations/compositions/variables-paced-module";

export default class CompositionsPacedModuleVariablesService {
    static async save(pacedModuleId, data) {
        return await axios.post(
            `${detailControllerRestUrl}?pacedModuleId=${pacedModuleId}`,
            JSON.stringify(data),
            {
                headers: {
                    "Content-Type": "application/json",
                },
            },
        );
    }

    static async edit(variableId, data) {
        return await axios.put(
            `${detailControllerRestUrl}/${variableId}`,
            JSON.stringify(data),
            {
                headers: {
                    "Content-Type": "application/json",
                },
            },
        );
    }

    static async delete(variableId) {
        return await axios.delete(`${detailControllerRestUrl}/${variableId}`, {
            headers: {
                "Content-Type": "application/json",
            },
        });
    }
}
